import * as angular from "angular";

export class InterceptorUtils {
    whiteListModel(data: any): any {
        if (!data) {
            return data;
        }

        if (Object.prototype.toString.call(data) === "[object Date]") {
            return data;
        }

        if (!angular.isDefined(data.requestIgnoreList)) {
            if (angular.isObject(data)) {
                data.requestIgnoreList = [];
            } else {
                return data;
            }
        }
        data.requestIgnoreList = data.requestIgnoreList.concat([
            "requestIgnoreList",
            "$q",
            "__env",
            "resource",
        ]);

        let tmp = {};
        for (let key in data) {
            let value = this.replacer(key, data[key], data.requestIgnoreList);
            if (value !== undefined) tmp[key] = value;
        }
        delete data.requestIgnoreList;
        return tmp;
    }

    replacer(key: string, value: any, requestIgnoreList: Array<any>): any {
        if (key && requestIgnoreList.indexOf(key) > -1) return undefined;
        else if (typeof value === "function") return undefined;
        else return value;
    }

    lookForIgnoreList(data: any) {
        if (data) {
            data = this.whiteListModel(data);
            if (
                angular.isArray(data) ||
                (angular.isObject(data) &&
                    Object.prototype.toString.call(data) !== "[object Date]")
            ) {
                if (Object.keys(data).length > 0) {
                    let tmp = {};
                    for (let key in data) {
                        if (Object.keys(key).length > 0) {
                            if (
                                angular.isDefined(key) &&
                                angular.isDefined(data[key])
                            ) {
                                if (
                                    angular.isArray(data[key]) &&
                                    !angular.isString(data[key])
                                ) {
                                    if (Object.keys(data[key]).length > 0) {
                                        tmp[key] = [];
                                        for (let key1 in data[key]) {
                                            let value = this.whiteListModel(
                                                data[key][key1]
                                            );
                                            value =
                                                this.lookForIgnoreList(value);
                                            if (value !== undefined)
                                                tmp[key].push(value);
                                        }
                                    } else {
                                        tmp[key] = data[key];
                                    }
                                } else if (angular.isObject(data[key])) {
                                    let value = this.whiteListModel(data[key]);

                                    value = this.lookForIgnoreList(value);
                                    if (value !== undefined) tmp[key] = value;
                                } else {
                                    tmp[key] = data[key];
                                }
                            }
                        }
                    }
                    data = tmp;
                }
            }
        }
        return data;
    }
}

angular.module("vcHelper").service("InterceptorUtils", InterceptorUtils);
